<template>
  <accounts-list :pagination.sync="pagination" @update:pagination="updateRoute" :filters.sync="filters" @update:filters="updateRoute" />
</template>
<script>
import AccountsList from '@/apps/accounts/components/List'
export default {
  components: {
    AccountsList
  },
  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: null,
        descending: true
      },
      filters: {}
    }
  },
  computed: {},
  methods: {
    updateRoute(pagination) {
      // this.$router.replace({ query: pagination })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/apps/accounts/views/List.vue